export const LINT = 1;
export const ELEVATION_ZINDEX = 1;



// WEBPACK FOOTER //
// ./node_modules/react-native-material-ui/src/styles/constants.js